import React, { useEffect, useState } from 'react';
import axios from 'axios';
import moment from 'moment';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { getCommunity } from 'helpers/community';
import { formatNumber, loader } from 'helpers/generic';

const TableMovements = styled.table`
    font-size: 12px;
    
    thead {

        tr {

            th {
                font-weight: 600;
            }
        }
    }

    th, 
    td {
        &:nth-child(1) {
            width: 80px;
        }

        &:nth-child(3) {
            width: 100px;
            text-align: right;
        }
    }
`;

const TableRemittance = styled.table`
    font-size: 12px;
    
    thead {
        tr {
            th {
                font-weight: 600;
            }
        }
    }

    th, 
    td {
        &:nth-child(1) {
            width: 80px;
        }

        &:nth-child(3),
        &:nth-child(4) {
            width: 100px;
            text-align: right;
        }
    }
`;

let axiosCancelToken = null;

export default function BankRemittance(props) {
    let hideModal = props.hideModal;

    let [loading, setLoading] = useState(false);
    let [remittance, setRemittance] = useState(undefined);
    let entity = props.movements.filter((item) => item.class.indexOf('BankRemittance') !== -1)[0] ?? null; 

    useEffect(() => {
		axiosCancelToken = axios.CancelToken.source();

        return function cleanup() {
            axiosCancelToken.cancel();
        }
    }, []);

    useEffect(() => {
        axios.get('/api/manager/bankremittances/get/' + entity.id, {
			params: {
				community_id: getCommunity()?.id,
			},
			cancelToken: axiosCancelToken.token
		}).then((response) => {
            setRemittance({...response.data});
	  	}).catch((error) => {
			if ( axios.isCancel(error) ) return;
		});	
    }, [entity]);

    const saveData = async () => {
        console.log(props.movements);
        setLoading(true);
        await axios.post('/api/manager/bank-reconciliation/save', {
            type: 'bankremittance',
            community_id: getCommunity()?.id,
            movements: props.movements
        }, {
			cancelToken: axiosCancelToken.token
		}).then((response) => {
			toast.success('Movimientos conciliados');
			hideModal(true, true);
	  	}).catch((error) => {
			hideModal(true);
			if ( axios.isCancel(error) ) return;
			toast.error('Ha ocurrido un error al guardar');
		});	
        setLoading(false);
    }

    let bankMovements = props.movements.filter((item) => item.class.indexOf('BankMovement') !== -1);
    let totalBankMovements = bankMovements?.reduce((carry, item) => carry += item.amount, 0) ?? 0;
    let validAmount = parseFloat(remittance?.total.toFixed(2)) <= parseFloat((totalBankMovements ?? 0).toFixed(2));

	return (
		<div className="row">
            { remittance?.id &&   
                <React.Fragment>
                    <div className="col-md-12 mb-3">
                        <label className="sbold">Movimientos bancarios a conciliar</label>
                        <TableMovements className="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>Fecha</th>
                                    <th>Concepto</th>
                                    <th>Importe</th>
                                </tr>
                            </thead>
                            <tbody>
                                {bankMovements.map((item, idx) => {
                                    return (
                                        <tr key={idx}>
                                            <td>{moment(item.date).format('DD-MM-YYYY')}</td>
                                            <td>{item.concept ?? ''}</td>
                                            <td>{formatNumber(item.amount ?? 0)}</td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                            <tfoot>
                                { bankMovements.length > 1 &&
                                    <tr>
                                        <td></td>
                                        <td></td>
                                        <td className="sbold">{formatNumber(totalBankMovements, 2)}</td>
                                    </tr>
                                }
                                { !validAmount &&
                                    <tr>
                                        <td colSpan="100%" className="text-danger text-center">
                                            El movimiento a conciliar tiene que tener un importe similiar o superior al importe de la remesa
                                        </td>
                                    </tr>
                                }
                            </tfoot>
                        </TableMovements>
                    </div>
                
                    <div className="col-md-12">
                        <label className="sbold">Remesa a conciliar</label>
                        <TableRemittance className="table table-sm table-bordered mb-0">
                            <thead>
                                <tr>
                                    <th>Fecha</th>
                                    <th>Nº</th>
                                    <th>Importe</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{remittance.payment_date ? moment(remittance?.payment_date).format('DD-MM-YYYY') : '-'}</td>
                                    <td>{remittance?.number_full ?? '-'}</td>
                                    <td>{formatNumber(remittance.total ?? 0)}</td>
                                </tr>
                            </tbody>
                        </TableRemittance>
                    </div>
                </React.Fragment>
            }

            { (remittance === undefined) && <div className="col-md-12"><div style={{width: '200px', margin: '0 auto'}} className="text-center">{loader}</div></div> }

            <div className="text-end mt-3">
				<button type="button" className="btn btn-primary text-white" onClick={() => saveData()} disabled={!validAmount || loading}>{loading ? 'cargando...' : 'Confirmar conciliación'}</button>
            </div>
        </div>
	);
}